import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import AllocationQuestion, {
  AllocationQuestionProps,
} from './AllocationQuestion';
import { InvestmentSplitWithAnswers } from './utils';
import { numberWithCommas } from 'shared/utils/numberUtils';

interface AllocationQuestionsProps extends AllocationQuestionProps {
  className?: string;
  investmentSplit: Required<InvestmentSplitWithAnswers>[];
  handleInvestmentIndexChange: (index: number) => unknown;
}

const StyledDiv = styled.div`
  .investment-questions.investment-modal-content {
    padding: ${SPACERS.extraLarge} ${SPACERS.medium};
    .investment-info {
      display: inline-block;
      color: ${COLORS.whiteBase};
      margin-bottom: ${SPACERS.tiny};
      padding: ${SPACERS.tiny} ${SPACERS.small};
      border-radius: ${SPACERS.extraTiny};
      border: 1px solid ${COLORS.blackBase};
      background-color: ${COLORS.grayDarkest};
    }
  }
  .investment-questions.investment-modal-content.content-even {
    background-color: ${COLORS.whiteBase};
  }
  .investment-questions.investment-modal-content.content-odd {
    background-color: #f3f3f3;
  }
  .try-again-button {
    margin: ${SPACERS.medium} auto;
  }
`;

const AllocationQuestions: React.FC<AllocationQuestionsProps> = props => {
  const { className, ...rest } = props;

  const x = props.investmentSplit[props.investmentFinalSplitIndex];

  if (!x) {
    return (
      <TrueImpactText color="critical">
        Unable to find this investment, please try refreshing the page!
      </TrueImpactText>
    );
  }

  return (
    <StyledDiv className={className}>
      <div
        key={x.program.Id}
        className="investment-questions investment-modal-content"
      >
        <TrueImpactText key={x.program.Id} align="center">
          <div className="investment-info">
            <strong>${numberWithCommas(x.amount)}</strong> will be allocated to{' '}
            <strong>{x.program.name}</strong> for the year{' '}
            <strong>{x.year}</strong>
          </div>
          <AllocationQuestion {...rest} investment={x} />
        </TrueImpactText>
      </div>
    </StyledDiv>
  );
};

export default AllocationQuestions;
